module.exports = __webpack_public_path__ + "static/images/challenge.22cb416b5241059c26c6f2155c4b5c20.png";